import { render, staticRenderFns } from "./haikangWX.vue?vue&type=template&id=229204bb&"
import script from "./haikangWX.vue?vue&type=script&lang=js&"
export * from "./haikangWX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports